import { render, staticRenderFns } from "./lecturerModule.vue?vue&type=template&id=090ae6aa&"
import script from "./lecturerModule.vue?vue&type=script&lang=js&"
export * from "./lecturerModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports